import { styled } from '@mui/material/styles';
import React from 'react';
import { getImageAssetUrl } from '../../../utils/assetUtils';
import { MOBILE_SCREEN_SIZE, TABLET_SCREEN_SIZE } from '../../../utils/constants';

export const StyledDialogContent: React.ComponentType<React.HTMLAttributes<HTMLDivElement> & { sx?: any }> = styled(
  'div',
)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch',
  textAlign: 'center',
  margin: '0 auto',
  position: 'relative',
  width: 'fit-content',
  gap: 10,
  '.img_container': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
  },
  '.logo': {
    width: 51,
    height: 51,
  },
  '.title': {
    color: `${theme.vars.palette.primary.main} !important`,
    marginTop: 10,
    marginBottom: 10,
    fontSize: 24,
    fontWeight: 'bold',
    [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      fontSize: 22,
    },
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 22,
    },
  },
  '.second-title': {
    color: `${theme.vars.palette.primary.main} !important`,
    fontSize: 20,
    fontWeight: 600,
    [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      fontSize: 18,
      fontWeight: 600,
    },
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 18,
      fontWeight: 600,
    },
  },
  '.subtitle': {
    color: `${theme.vars.palette.primary.main} !important`,
    fontSize: 18,
    fontWeight: 500,
    maxWidth: 380,
    [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      fontSize: 14,
    },
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 14,
    },
  },
  '.phone-input-container': {
    margin: '12px auto',
    'div:first-of-type': {
      alignItems: 'center',
    },
  },
  '.arrow-text': {
    justifyContent: 'center',
  },
  '.video-container': {
    maxWidth: 314,
    maxHeight: 414,
  },
  '.share-container': {
    paddingTop: 10,
  },
}));
type StyledDialogContentProps = React.ComponentProps<typeof StyledDialogContent>;

interface ProductPageDialogContentProps {
  imageUrl?: string;
  imageSize?: number;
  showIcon?: boolean;
  title?: string;
  secondTitle?: string;
  subtitle?: string;
  children: React.ReactNode;
  sx?: StyledDialogContentProps['sx'];
  iconProps?: {
    src?: string;
    alt?: string;
    style?: React.CSSProperties;
  };
}

export const ProductPageDialogContent: React.FC<ProductPageDialogContentProps> = ({
  imageUrl,
  imageSize = 51,
  showIcon,
  title,
  secondTitle,
  subtitle,
  children,
  ...props
}) => {
  return (
    <StyledDialogContent
      className="styled-dialog-content"
      sx={{
        paddingBottom: '55px',
        ...props.sx,
      }}
    >
      {imageUrl && (
        <div className="img_container">
          <img
            loading="lazy"
            src={imageUrl}
            alt=""
            style={{ width: imageSize, height: imageSize, objectFit: 'contain' }}
          />
        </div>
      )}
      {showIcon && (
        <div>
          <img
            loading="lazy"
            src={getImageAssetUrl('brandclub-b-logo.webp')}
            alt=""
            className="logo"
            {...props.iconProps}
          />
        </div>
      )}
      {title && <div className="title">{title}</div>}
      {secondTitle && <div className="second-title">{secondTitle}</div>}
      {subtitle && <div className="subtitle">{subtitle}</div>}
      {children}
    </StyledDialogContent>
  );
};
